import { trackClickFeature } from 'utilities/tracking';
import { COMPONENT_NAMES } from 'constants/tracking';

const onCartPageClick = ({
  featureId,
  featureName,
  componentName,
  eventDescription,
  actionItem,
  subActionItem,
  additionalParameters,
}) => {
  trackClickFeature({
    featureId,
    featureName,
    componentName: componentName || COMPONENT_NAMES.APPS.CART.YOUR_CART,
    eventDescription: eventDescription || `Click ${actionItem}`,
    actionItem,
    subActionItem,
    additionalParameters,
  });
};

export { onCartPageClick };
